import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage.tsx';
import { Loader } from '@openx/components-core/lib/Loader/Loader.tsx';
import { PageHeader } from '@openx/components-header/PageHeader.tsx';
import { Feature_Flags_Enum } from '@openx/types/gqlTypes.ts';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router';
import { useAuth } from '../../components/AuthContext/context.ts';
import { isMasterOrganisation } from '../../permissions/validators.ts';
import { useFeatureFlag } from '../featureFlags/useFeatureFlag.ts';
import { CuratedDealBuyerDiscountsForm } from './Form/CuratedDealBuyerDiscountsForm.tsx';
import { useCuratedDealBuyerDiscountFetch } from './hooks/useCuratedDealBuyerDiscountFetch.ts';

type CuratedDealBuyerDiscountsFormPageParams = {
  curatedDealBuyerDiscountUid: string;
};

export const CuratedDealBuyerDiscountsFormPage = () => {
  const { session } = useAuth();
  const hasCuratedDealBuyerDiscountFeature = useFeatureFlag(Feature_Flags_Enum.CuratedDealBuyerDiscount);
  const { curatedDealBuyerDiscountUid = '' } = useParams<CuratedDealBuyerDiscountsFormPageParams>();
  const { curatedDealBuyerDiscount, demandPartnerName, isError, isLoading, seatById } =
    useCuratedDealBuyerDiscountFetch(curatedDealBuyerDiscountUid);

  const { t } = useTranslation();

  const isEdit = !!curatedDealBuyerDiscountUid;
  const isMasterOrg = isMasterOrganisation(session);
  const title = isEdit ? t('Edit Discount') : t('Create New Discount');

  if (isError) {
    return <Navigate replace to="/error" />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (!hasCuratedDealBuyerDiscountFeature || isMasterOrg) {
    return <AccessForbiddenPage />;
  }

  return (
    <PageHeader titlePrefix="OpenXSelect" title={title}>
      <CuratedDealBuyerDiscountsForm
        curatedDealBuyerDiscount={curatedDealBuyerDiscount}
        demandPartnerName={demandPartnerName}
        seatById={seatById}
      />
    </PageHeader>
  );
};
